import { ComponentProps } from 'react';
import NextLink from 'next/link';

type LinkProps = ComponentProps<typeof NextLink> & {
  href: string;
};

export function Link({ href, children, ...props }: LinkProps) {
  const isExternal = href.startsWith('http') && !href.includes('donate.starlight.org');

  if (isExternal) {
    return (
      <a href={href} target='_blank' rel='noopener noreferrer' {...props}>
        {children}
      </a>
    );
  }

  return (
    <NextLink href={href} {...props}>
      {children}
    </NextLink>
  );
}
